module.exports = __webpack_public_path__ + "img/filter-circle-xmark.bc7e3d58.svg";